/**
 * 導師入駐 PC 首頁 — English (nested for t('mentorJoin.indexPc.…'))
 */
export default {
	banner: {
		title: "Share Your <span>Wisdom</span> with the ",
		title2: "World as a Global Life Mentor",
		titleM: "Share Your <span>Wisdom</span><br/> with the World as a",
		title2M: "Global Life Mentor",
		body: {
			title: "This Is for You If You:",
			text1:
				"· Specialize in psychology, mind-body healing, tarot, astrology, Eastern metaphysics, spiritual wellness, or emotional support",
			text2:
				"· Can provide professional online consultations to help clients build self-understanding and self-acceptance",
			text3: "· Have your own teaching framework and standardized courses",
			text4: "· Want to grow a side business and earn stable income",
			text5: "· Hope to access global client resources and greater international exposure",
		},
		joinCta: "Join Now",
	},
	section1: {
		sectionTitle:
			"SeerQ: Let Mentor Wisdom <span>Be Seen, Trusted <br/>and Transformed into Business Value.</span>",
		sectionTitle2:
			"The platform creates diversified value-conversion channels for mentors, covering core ",
		sectionTitle3:
			"scenarios such as instant consultations, high-value connections, and content monetization, <br/>helping mentors continuously transform their professional expertise into commercial value.",
		sectionTitleM:
			"The platform creates diversified value-conversion channels for mentors, covering core scenarios such as instant consultations, high-value connections, and content monetization, helping mentors continuously transform their professional expertise into commercial value.",
		title1: "Brand Support",
		text1:
			"Full-media IP incubation program, helping you expand internationally with dedicated operational and resource support.",

		title2: "Global Payments",
		text2:
			"Integrated with a global payment system, supporting multi-currency transactions for seamless cross-border payments.",
		title3: "Technology Empowerment",
		text3:
			"AI-powered digital operations upgrade, SaaS tools, and advertising support to turn digital transformation into profitable growth.",
		title4: "Service Assurance",
		text4:
			"24/7 technical support to ensure stable business operations and a smooth service experience throughout the entire process.",
		// title2: "流量扶持",
		// text2: "量身打造個人形象、推廣方案與IP定位，千萬級流量全域曝光。",
	},
	section2: {
		sectionTitle:
			"<span>Enjoy Exclusive Mentor Benefits Upon</span> Joining<br/> and Elevate Your Professional Value",
		title1: "Exclusive Opera- tions Support",
		text1:
			"Get dedicated one-on-one operations consulting and full onboarding support to help you launch efficiently and join with ease.",
		title2: "Traffic Support",
		text2:
			"Build your personal brand, promotion strategy, and IP positioning, gaining exposure across tens of millions of traffic sources.",
		title3: "Customized Services",
		text3:
			"Support for launching personalized service plans, helping you fully leverage your expertise and expand into higher-value service scenarios.",
		title4: "Priority Access to Events",
		text4:
			"Gain priority access to major platform events, secure more brand exposure opportunities, and amplify your personal influence and commercial value.",
	},
	join: {
		sectionTitle: "Mentor Onboarding Process",
		centerImageAlt: "SeerQ",
		step1: {
			title: "Submit Application",
			desc: 'Click <span class="join-step-link" role="button" tabindex="0">“Join Now,”</span><br/> complete your basic<br/> profile, mentor <br/>credentials, and <br/>professional<br/> assessment.',
		},
		step2: {
			title: "Platform Review",
			desc: "We will review your <br/>qualifications and <br/>expertise. Results will<br/> be sent by email within<br/> 10 business days.",
		},
		step3: {
			title: "Verify & Sign",
			desc: "Once approved,<br/> complete identity ,<br/> then sign the <br/>agreement online.",
		},
		step4: {
			title: "Activate Dashboard",
			desc: "Add your operations <br/>contact, and we’ll<br/> activate your<br/> dedicated mentor <br/>dashboard.",
		},
		step5: {
			title: "Launch Services",
			desc: "Set up your services,<br/> start receiving <br/>consultations, and offer professional <br/>guidance.",
		},
	},
	joinM: {
		step1: {
			title: "Submit Application",
			desc: 'Click <span class="join-step-link" role="button" tabindex="0">“Join Now,”</span> complete your basic profile, mentor credentials, and professional  assessment.',
		},
		step2: {
			title: "Platform Review",
			desc: "We will review your qualifications and expertise. Results will be sent by email within 10 business days.",
		},
		step3: {
			title: "Verify & Sign",
			desc: "Once approved, complete identity , then sign the agreement online.",
		},
		step4: {
			title: "Activate Dashboard",
			desc: "Add your operations contact, and we’ll activate your dedicated mentor dashboard.",
		},
		step5: {
			title: "Launch Services",
			desc: "Set up your services, start receiving consultations, and offer professional guidance.",
		},
	},
	section3: {
		title: "Mentor Testimonials",
		desc: "Let your expertise shine and your value grow. Listen to true stories from mentors who unlocked their potential and advanced their careers on SeerQ.",
	},
	section4: {
		title:
			"SeerQ: <span>Where Technology Meets Cultural Wisdom</span> Your One-Stop Platform for Wellness and Life Planning",
		dec1: "The world’s first culture-based wellness super app designed for Asian communities, <br/>pioneering a new category of digital wellness guidance powered by traditional Asian wisdom. <br/>",
		dec2: "<br/>SeerQ is building an integrated wellness companion super app that combines content-driven<br/> growth, transaction monetization, and AI-powered services, creating a closed-loop platform <br/>from content to commerce. ",
		dec3: "",
		decM: "The world’s first culture-based wellness super app designed for Asian communities, pioneering a new category of digital wellness guidance powered by traditional Asian wisdom. ",
		decM2:
			"SeerQ is building an integrated wellness companion super app that combines content-driven growth, transaction monetization, and AI-powered services, creating a closed-loop platform from content to commerce. ",
		beimei: "North America\n15%",
		qita: "Other Regions\n25%",
		dongnanya: "Southeast Asia\n50%",
		rihan: "Japan & South Korea\n10%",
	},
	teacherCircle: {
		title: "Mentor Team",
		dec: "Over 200 Global ",
		dec2: "Mentor Partners",
	},
	cooperativeMedia: {
		title: "Media Partnerships",
		groupTv: "Television/Radio",
		groupPlatform: "OTT Platforms",
		groupChannel: "Multi-Channel New Media Exposure",
		groupMedia: "Print and Online Media",
	},
	section5: {
		sectionTitle: "Featured Mentors",
		title1: "Feng Sui",
		text1:
			"Feng Sui is the champion of Hong Kong TV show King of Psychics 2. He is well-versed in traditional Chinese metaphysics including Four Pillars of Destiny, I Ching Feng Shui and Plum Blossom Divination. He provides personalized consultations for clients to sort out career development, life blueprint and residential spatial planning, delivering clear, actionable guidance and practical solutions tailored to their fortunes.",
		title2: "Mak Lingling",
		text2:
			"Mak Lingling is one of Hong Kong’s most popular numerologists, specializing in marriage forecasting, Bazi destiny analysis, and home Feng Shui. With a vivid and relatable style, she brings traditional wisdom into modern life and is widely trusted by the public.",
		title3: "Fa Ming",
		text3:
			"Fa Ming specializes in root-cause analysis through the “Heavenly Eye” and blessing techniques, combining Qimen Dunjia and Bazi Feng Shui to decode invisible connections and provide personalized fortune guidance.",
		title4: "Master Chiu",
		text4:
			"Master Chiu specializes in deep studies of Bazi and Feng Shui, transforming complex knowledge into clear, easy-to-understand life guidance. Focusing on clients’ careers, relationships, and home environments, he provides practical solutions.",
		title5: "Lin He",
		text5:
			"Master Lin He is known as a “Feng Shui strategist for the younger generation.” He specializes in interpreting traditional wisdom such as Bazi, Feng Shui, and Plum Blossom Numerology through modern language and a younger perspective.",
	},
	loginModal: {
		tabEmail: "Email Login",
		tabPhone: "Phone Login",
		mPrivacy: "We protect your privacy. This information will not be visible to others.",
		mPhoneStepTitle: "Enter your phone number",
		mEmailStepTitle: "Enter your email",
		mAreaCodeLabel: "Area code",
		mSwitchToEmail: "Sign up / log in with email >",
		mSwitchToPhone: "Sign up / log in with phone >",
		mNext: "Next",
		mInvalidEmail: "Please enter a valid email address",
		mVerificationTitle: "Enter verification code",
		mVerificationSentPrefix: "We have sent a verification code to",
		mResendWait: "Resend code in {n}s",
		mResendLink: "Resend verification code",
		mToastCodeSent: "Verification code sent",
		mToastCodeSendFail: "Failed to send verification code. Please try again.",
		mToastLoginCodeWrong: "Login failed. Please check your verification code.",
		mToastSelectAreaCode: "Please select an area code",
		mToastCompleteCaptcha: "Please complete the captcha first",
		mToastCaptchaFail: "Verification failed. Please try again.",
		mToastCaptchaExpired: "Verification expired. Please verify again.",
		mToastCaptchaUnsupported:
			"Verification is not supported in this browser. Please use another browser.",
		mPhonePlaceholder: "Enter your phone number",
		mEmailPlaceholder: "Please enter your email",
		mCodePlaceholderPhone: "Enter phone verification code",
		mCodePlaceholderEmail: "Enter email verification code",
		mGetCode: "Get code",
		mLogin: "Log in",
		mBack: "Go back",
		bindTitle: "Please enter your email to bind your account",
		bindDesc: "If you have any questions, please contact customer support",
		bindBtn: "Bind",
		kefu: "Customer Support",
		loginSuccess: "Logged in successfully",
	},
	gate: {
		finishCreatorFirst:
			"Please complete your creator application review before applying as a mentor.",
	},
	messagePop: {
		back: "Back",
		alreadyTeacher: {
			title: "Welcome to SeerQ",
			desc: "You are now a contracted mentor on SeerQ. Download the See Beyond app to accept orders and provide guidance to users.",
		},
		notPass: {
			title: "We're sorry, your mentor qualification review was not approved.",
			desc: "Thank you for your interest and application. Based on this review result, you cannot continue the onboarding process at this time. Thank you for your understanding.",
		},
		inReview: {
			title: "Teacher Certification in Progress",
			desc: "Your information has been submitted for review. It cannot be modified while under review.",
			desc2:
				"Our review team will respond via email within 10 business days. Please check your email for updates. You may also download the See Beyond app to receive real-time notifications regarding review progress and results. Thank you for your cooperation and support.",
		},
	},
};
